export const testimonials = [
  {
    quote: "We appreciate Dr. Manish Goel for his mission 'Har Ghar Moringa' (Drum Stick) and thanks for planting Moringa plants in our society.",
    name: "Secretary",
    role: "Secretary",
    organization: "Rishi Co-Op. Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We appreciate Dr. Manish Goel for his Mission 'Har Ghar Moringa' (Drum Stick) and thanks for planting Moringa in our Society.",
    name: "Dr. S.L. Sagar",
    role: "President",
    organization: "The Overseas Young Friends Co-operative Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We appreciate Dr Manish Goel, founder of SWADHAY, for his Mission 'Har Ghar Moringa'. We are also thankful to him and his team for planting Moringa plants in our society and enlightening people about its medicinal qualities.",
    name: "President",
    role: "President",
    organization: "IVT Co-operative Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We would like to thank you and your team for conduct Yoga Sessions at The Rajputana Rifles Regiment Centre for our troops (Approx 600 persons). We are quite sure that with your dedication and hardwork you and your group (SWADHYAY) will grow and succeed in your endeavors and mission in the future.",
    name: "Lt Col Vikash Jhajhria",
    role: "Adjutant",
    organization: "The Rajputana Rifles Regimental Centre",
    location: "PIN - 900106"
  },
  {
    quote: "We appreciate DR. Manish Goel, Founder-SWADHYAY FOR HIS MISSION 'HAR GHAR MORINGA'(DRUM STICK) and thanks for planting Moringa Plants in our Society.",
    name: "Sunil Datt Sharma",
    role: "Secretary",
    organization: "The Farmers' Co-operative Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "It has been a great pleasure to have your esteemed presence as an expert to provide much needed guidance to various schools/teachers. Your talk on 'Healthy lifestyle' was appreciated by all teachers.",
    name: "Principal",
    role: "Principal",
    organization: "S.D. Public School",
    location: "Delhi"
  },
  {
    quote: "We feel proud of your lecture among the students and staff. You have aware the students not to eat outside snacks and eatables. You also stressed on NATURE CARE, How the natural food can help our body to digest the things. You talked about YOGA also.",
    name: "Managing Director",
    role: "Managing Director",
    organization: "Evergray High School",
    location: "Kaithal"
  },
  {
    quote: "I on behalf of all ranks & families of 505 Army Base Wksp would like to express my sincere gratitude & thanks for conducting scintillating Yoga session. I am sanguine that dedication & hard works of your team (SWADHYAY) for such noble cause will benefit society.",
    name: "Col Vimal Sharma, SM",
    role: "General Manager (Pers & Adm)",
    organization: "505 Army Base Workshop EME",
    location: "PIN - 900106"
  },
  {
    quote: "We appreciate Dr Manish Goel founder SWADHYAY for his mission 'HAR GHAR MORINGA' (drum stick) and thanks for planting Moringa plants in our society.",
    name: "President, Secretary, Treasurer",
    role: "Management",
    organization: "Vishwa Vihar Co-op Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We would like to thank you and your team for conducting Yoga sessions at Liaison Office Assam Rifles for our troops (approx.. count 65 persons) and their families. We are quite sure that with your dedication and hard work you and your group (SWADHYAY) will grow and succeed in your endeavors and mission in the future.",
    name: "Resident Asst Director",
    role: "Resident Asst Director",
    organization: "Assam Rifles, Ministry of Home Affairs",
    location: "Delhi Cantt"
  },
  {
    quote: "We are very thankful to you for planting Har Ghar Moringa (Drum Stick) in our Society. This will remain your permanent Memories in coming years! future.",
    name: "Honorary President",
    role: "Honorary President",
    organization: "New Deluxe Co-operative Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We Appreciate Dr. Manish Goel, Founder – Swadhyay, For his mission 'Har Ghar Moringa' (Drum Stick) and thanks for planting Moringa Plants in our School.",
    name: "Ms. Ambika Roshan",
    role: "Principal",
    organization: "Maharaja Aggarsain Adarsh Public School",
    location: "Pitampura, Delhi"
  },
  {
    quote: "WE ARE APPRECIATE Dr. MANISH GOEL, FOUNDER –SWADHYAY, FOR HIS MISSION 'HAR GHAR MORINGA' (DRUM STICK) AND THANKS FOR PLANTINGMORINGA PLANTSIN OUR SOCIETY",
    name: "President",
    role: "President",
    organization: "Shree Jagdambay Co-op. Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We appreciate Dr. Manish Goel, Founder- 'SWADHYAY' For His Mission 'HAR GHAR MORINGA'(DRUM STICK) and Thanks for planting Moringa plants in our school.",
    name: "Principal",
    role: "Principal",
    organization: "North Delhi Municipal Corporation Primary School",
    location: "Rohini, Delhi"
  },
  {
    quote: "We would like to thank you and your team for conduct or Yoga Session at Rajputana Rifles Centre for our troops on 05 June 2023 and families on 10 June 2023. We are quite sure that with your dedication and hard work you and your group (SWADHYAY HEALTH CARE) will grow and succeed in your endeavors and mission in the future.",
    name: "Commandant",
    role: "Commandant",
    organization: "Rajputana Rifles Regimental Centre",
    location: "PIN - 900106"
  },
  {
    quote: "We appreciate Dr. Manish Goel, Founder-SWADHYAY, For his mission 'Har Ghar Moringa' (Drum stick) and thanks for planting Moringa plants in our Society.",
    name: "Rahul (Rahul Atri)",
    role: "Representative",
    organization: "Vasudha Co-operative Group Housing Society Ltd.",
    location: "Rohini, Delhi"
  },
  {
    quote: "We feel proud of your lecture among the students and staff. You have aware the students not to eat outside snacks and eatables. The students and the staff impressed by the experiment you have done. The students promised and take oath not to eat street food.",
    name: "Managing Director",
    role: "Managing Director",
    organization: "Evergray High School",
    location: "Amar Garh Colony, Kaithal"
  },
  {
    quote: "We would like to thank you and your team for conduct or Yoga Session at Rajputana Rifles Centre for our troops and families. We are quite sure that with your dedication and hard work you and your group (SWADHYAY) will grow and succeed in your endeavors and mission in the future.",
    name: "Lt Col Vikash Jhajhria",
    role: "Adjutant",
    organization: "The Rajputana Rifles Regimental Centre",
    location: "PIN - 900106"
  },
  {
    quote: "We sincerely thank Swadhya Seva Foundation for organizing NEAC 2025–26, a well-structured and impactful program that promoted value-based learning and personal growth among students. We appreciate the dedication and efforts of the entire team in making the initiative successful and enriching.",
    name: "Vibha Gupta",
    role: "Principal",
    organization: "Delhi Heritage School",
    location: "Rohini, Delhi"
  },
  {
    quote: "SNEAC 2025–2026 provided a well-structured learning platform that positively impacted students’ learning behaviour, motivation, communication skills, and real-world understanding. Teachers observed improved classroom participation and collaboration, making the programme a valuable initiative in developing confident, skilled, and responsible learners.",
    name: "Principal",
    role: "Principal",
    organization: "Akal Academy Ajitsar ,Ratia",
    location: "Ratia V.P.O Hamjapur Fatehabad Haryana 125051"
  },
  {
    quote: "The Environment Quiz under SNEAC 2025–26, conducted by Swadhya Seva Foundation at Mayoor School, Noida, effectively promoted critical thinking and real-life environmental awareness among students. The team demonstrated high professionalism, punctuality, and coordination, making the event engaging and interactive. Such initiatives foster environmental responsibility, and we look forward to future collaborations.",
    name: "Alka Awasthi",
    role: "Principal",
    organization: "Mayoor School Noida",
    location: "Noida, Uttar Pradesh"
  },
  {
    quote: "The school proudly participated in the Swadhyay National Environment Awareness Competition 2025–26, which was informative, engaging, and thoughtfully designed. The quiz enhanced students’ understanding of environmental issues while promoting critical thinking and responsible citizenship. We appreciate Swadhyay Seva Foundation’s efforts in fostering environmental awareness and look forward to future participation.",
    name: "Sovanika Pal",
    role: "Principal",
    organization: "Vidya Bharti School",
    location: "Rohini, Delhi"
  },
  {
    quote: "Maharishi Vidya Mandir School, Nadaun appreciates Swadhyay Seva Foundation for conducting a meaningful, well-organized, and educational programme. The initiative effectively promoted environmental awareness and social responsibility among students through engaging activities. The team’s dedication and professionalism are commendable, and we look forward to future collaborations.",
    name: "Sh. Sushil Kumar Awasthi",
    role: "Principal",
    organization: "Maharishi Vidya Mandir School",
    location: "Nadaun, Himachal Pradesh"
  }
];
